module.exports = __webpack_public_path__ + "media/eat4.9e84a465.mp4";